module.exports = __webpack_public_path__ + "static/media/logo_facepay.4cefb8b6.svg";